export const PROGRAM = {
    id: 1,
    name: 'Program',
    value: 'PROGRAM',
    sequence: 1,
};
export const SUBJECT = {
    id: 2,
    name: 'Subject',
    value: 'SUBJECT',
    sequence: 2,
};
export const LEARNING_PLAN = {
    id: 3,
    name: 'Learning Plan',
    value: 'LEARNING_PLAN',
    sequence: 3,
};
export const LP_CATEGORY = {
    id: 4,
    name: 'LP Category',
    value: 'LP_CATEGORY',
    sequence: 4,
};
export const LP_MODULE = {
    id: 5,
    name: 'LP Module',
    value: 'LP_MODULE',
    sequence: 5,
};
export const CONTENT = {
    id: 6,
    name: 'Content',
    value: 'CONTENT',
    sequence: 6,
};
export const Basic = [
    PROGRAM,
    SUBJECT,
    LEARNING_PLAN,
    LP_CATEGORY,
    LP_MODULE,
    CONTENT,
];
export const BasicByValue = Basic.reduce((hash, type) => {
    hash[type.value] = type;
    return hash;
}, {});
export const BasicValues = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicValues,
    PROGRAM,
    SUBJECT,
    LEARNING_PLAN,
    LP_CATEGORY,
    LP_MODULE,
    CONTENT,
};
export const computedValues = (programType, subjectType, learningPlanType) => {
    const PROGRAM = {
        id: 1,
        name: programType,
        value: 'PROGRAM',
        sequence: 1,
    };
    const SUBJECT = {
        id: 2,
        name: subjectType,
        value: 'SUBJECT',
        sequence: 2,
    };
    const LEARNING_PLAN = {
        id: 3,
        name: learningPlanType,
        value: 'LEARNING_PLAN',
        sequence: 3,
    };
    const Basic = [
        PROGRAM,
        SUBJECT,
        LEARNING_PLAN,
        LP_CATEGORY,
        LP_MODULE,
        CONTENT,
    ];
    const BasicByValue = Basic.reduce((hash, type) => {
        hash[type.value] = type;
        return hash;
    }, {});
    const BasicValues = Object.keys(BasicByValue);
    return {
        Basic,
        BasicByValue,
        BasicValues,
        PROGRAM,
        SUBJECT,
        LEARNING_PLAN,
        LP_CATEGORY,
        LP_MODULE,
        CONTENT,
    };
};
